import get_ from 'lodash/get'
import { call, put, takeEvery } from 'redux-saga/effects'
import { privateFetch } from '../../../fetch'
import { FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO } from '../../../../actions/actionTypes'
import { API_URL_PATH_VENUE_COLLECTION_INFO } from '../../../../../constants'
import {
  fetchKegCollectionBookingVenueCollectionInfoRequest,
  fetchKegCollectionBookingVenueCollectionInfoFailure,
  fetchKegCollectionBookingVenueCollectionInfoSuccess,
  saveKegCollectionBookingVenueCollectionInfo,
} from './utils'

function* fetchVenueCollectionInfoWorker(action) {
  if (!action) return
  const { venueId } = action.payload || {}
  yield put(fetchKegCollectionBookingVenueCollectionInfoRequest())

  try {
    const response = yield call(privateFetch, {
      path: `${API_URL_PATH_VENUE_COLLECTION_INFO}/${venueId}`,
      method: 'GET',
    })
    yield call(doSuccess, response.data)
  } catch (error) {
    if (get_(error, 'response.status') === 404) {
      yield call(doSuccess, null)
      return
    }
    yield call(doFailure, error)
  }
}

export default [
  [takeEvery, FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO, fetchVenueCollectionInfoWorker],
]

function* doSuccess(response) {
  yield put(saveKegCollectionBookingVenueCollectionInfo(response))
  yield put(fetchKegCollectionBookingVenueCollectionInfoSuccess())
}

function* doFailure(error) {
  yield put(fetchKegCollectionBookingVenueCollectionInfoFailure(error))
}
